export default __webpack_public_path__ + "ae71fb7ebea26e093135d794d080a4fa.png";